import { render } from "./oti_create.vue?vue&type=template&id=bca9dc40"
import script from "./oti_create.vue?vue&type=script&lang=js"
export * from "./oti_create.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__